export const FIX_RATE = "3,3";
export const VARIABLE_RATE = "4,88";
